import React from "react"
import { graphql } from "gatsby"
import Image from "gatsby-image"

import { rhythm } from "../utils/typography"
import Layout from "../components/layout"
import SEO from "../components/seo"

const About = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title

  const clientImgA = data.clients.edges.find(
    element => element.node.name === "client-logo-ketchum-pr"
  )
  const clientImgB = data.clients.edges.find(
    element => element.node.name === "client-logo-rhs"
  )
  const clientImgC = data.clients.edges.find(
    element => element.node.name === "client-logo-huddart-consulting"
  )
  const clientImgD = data.clients.edges.find(
    element => element.node.name === "client-logo-yoga"
  )
  const clientImgE = data.clients.edges.find(
    element => element.node.name === "client-logo-we-pioneer"
  )
  const clientImgF = data.clients.edges.find(
    element => element.node.name === "client-logo-sleepasloth"
  )

  return (
    <Layout location={location} title={siteTitle}>
      <SEO title="About" />
      <Image
        fluid={data.mast.childImageSharp.fluid}
        alt="Me"
        style={{
          maxWidth: `100%`,
          marginBottom: rhythm(1 / 2),
          marginLeft: `auto`,
          marginRight: `auto`,
          marginTop: 0,
        }}
      />
      <div style={{ margin: `auto`, maxWidth: rhythm(34) }}>
        <section>
          <h1
            style={{
              textAlign: `center`,
              margin: `4rem 0 2rem`,
              padding: `0 1rem`,
              textTransform: "none",
            }}
          >
            Strategic video production designed to build trust and support your
            marketing long-term
          </h1>

          <div className="grid align-center">
            <div className="col col-6">
              <p>I'm Iris Gibson, founder of Crafted Films.</p>
              <p>
                I work as a producer/director, leading strategic video projects
                for independent brands and organisations across the UK and
                Europe.
              </p>
              <p>
                With over 16 years' experience in the industry, I've
                collaborated with clients including The Royal Horticultural
                Society, Habitat, Merck, Southeastern and Whole Foods - shaping
                films that communicate clearly, build trust and support
                long-term marketing goals.
              </p>
            </div>
            <div className="col col-6">
              <Image
                fluid={data.mastIris.childImageSharp.fluid}
                alt="Me"
                style={{
                  maxWidth: `360px`,
                  marginBottom: rhythm(1 / 2),
                  marginLeft: `auto`,
                  marginRight: `auto`,
                  marginTop: 0,
                }}
              />
            </div>
          </div>

          <div className="grid align-center">
            <div className="col col-6">
              <Image
                fluid={data.producersPerspective.childImageSharp.fluid}
                alt="Me"
                style={{
                  maxWidth: `330px`,
                  marginBottom: rhythm(1 / 2),
                  marginLeft: `auto`,
                  marginRight: `auto`,
                  marginTop: 0,
                }}
              />
            </div>
            <div className="col col-6">
              <h2 style={{ marginTop: 0 }}>A Producer's Perspective</h2>
              <p>My role goes beyond filming.</p>
              <p>
                Every project begins with understanding your objectives, your
                audience and how a film needs to function within your wider
                marketing.
              </p>
              <p>
                From there, I shape the concept, guide the narrative and oversee
                production from start to finish, assembling a trusted network of
                specialist crew depending on the scale and needs of the project.
              </p>

              <p>
                The result is a process that feels considered, collaborative and
                reassuring and a film that genuinely reflects the depth and
                personality of your brand.
              </p>
            </div>
          </div>

          <div className="grid align-center">
            <div className="col col-6">
              <h2 style={{ marginTop: "0.5rem" }}>Film as a long-term asset</h2>
              <p>
                The most effective films aren't created for a moment, they're
                shaped to support the business over time.
              </p>
              <p>
                A well-crafted brand film can anchor your website, strengthen
                perception and support campaigns in a way that feels cohesive
                rather than reactive. When it's done well, it builds trust
                quietly and consistently.
              </p>
              <p>
                I'm particularly drawn to organisations with real substance
                behind them. Businesses with purpose, craft or heritage that
                deserve to be communicated clearly and thoughtfully.
              </p>
            </div>
            <div className="col col-6">
              <Image
                fluid={data.longTermAsset.childImageSharp.fluid}
                alt="Me"
                style={{
                  maxWidth: `290px`,
                  marginBottom: rhythm(1 / 2),
                  marginLeft: `auto`,
                  marginRight: `auto`,
                  marginTop: 0,
                }}
              />
            </div>
          </div>

          <div className="grid align-center">
            <div className="col col-6">
              <Image
                fluid={data.onSet.childImageSharp.fluid}
                alt="Me"
                style={{
                  maxWidth: `420px`,
                  marginBottom: rhythm(1 / 2),
                  marginLeft: `auto`,
                  marginRight: `auto`,
                  marginTop: 0,
                }}
              />
            </div>
            <div className="col col-6">
              <h2 style={{ marginTop: 0 }}>A Boutique Studio Model</h2>
              <p>
                Crafted Films offers a boutique, streamlined alternative to
                larger agencies, combining strategic oversight with hands-on
                creative leadership.
              </p>
              <p>
                On larger productions, I assemble a trusted team of specialists
                to suit the needs of the project, ensuring flexibility without
                compromising quality.
              </p>
              <p>
                This approach allows for carefully crafted, high-quality work
                that feels polished, authentic and aligned with your wider
                business goals.
              </p>
            </div>
          </div>
        </section>

        <section style={{ marginTop: "6rem" }}>
          <h1 style={{ textAlign: `center` }}>Client Testimonials</h1>

          <div className="grid">
            <div className="col col-6">
              {clientImgA ? (
                <div
                  style={{
                    display: "flex",
                    height: "120px",
                    alignItems: "center",
                  }}
                >
                  <Image
                    fixed={clientImgA.node.childImageSharp.fixed}
                    style={{ display: `flex`, margin: `1rem auto` }}
                  />
                </div>
              ) : (
                ""
              )}
              <p>
                'I can highly recommend Iris for her high degree of
                professionalism on every project we have partnered on. She has a
                strong understanding of storytelling and is very organised when
                it comes to content production and getting key logistical
                elements in place.
              </p>
              <p>
                She also has great attention to detail and when it comes to the
                final “on-air” product - manages to ensure that messages are
                told in a clever, visual manner. Having spent long periods of
                time on the road with Iris doing overseas jobs, she is also
                great company and calm at times of challenge. I cannot recommend
                her highly enough.'
              </p>
              <p>
                <strong>
                  RICHARD GRIFFITHS <br />
                  Director, Strategic Communications at Ketchum
                </strong>
              </p>
            </div>
            <div className="col col-6">
              {clientImgB ? (
                <div
                  style={{
                    display: "flex",
                    height: "120px",
                    alignItems: "center",
                  }}
                >
                  <Image
                    fixed={clientImgB.node.childImageSharp.fixed}
                    style={{ display: `flex`, margin: `1rem auto` }}
                  />
                </div>
              ) : (
                ""
              )}
              <p>
                Having worked together for a number of years, across a range of
                projects, I cannot recommend Iris highly enough.
              </p>
              <p>
                Aside from being professional, organised and so easy to work
                with, Iris' creativity shines through in everything she
                produces. She understands what we need from a film (even when we
                don't know ourselves) and always delivers honest, beautiful and
                sensitive stories.
              </p>
              <p>
                I can trust that a day on set with the Crafted Films team will
                be a smooth and enjoyable one! Everyone is always on time,
                prepared, and ready for a full day of filming. When conducting
                interviews Iris' calm, confident attitude puts everyone at ease
                - both in front of and behind the camera.
              </p>
              <p>
                I am always confident that final films will be delivered on time
                and edited to a very high standard. There is a strong sense of
                place, people and story in all the videos that Iris has created
                for us and we love the authenticity that each has to it's
                subjects. They all show a deep understanding of our needs, as
                well as representing everyone involved perfectly.
              </p>
              <p>
                <strong>
                  ABBIE CHADWICK <br />
                  Communications Officer, Schools and Groups <br />
                  RHS Horticulture, Education and Communities
                </strong>
              </p>
            </div>
          </div>

          <div className="grid">
            <div className="col col-6">
              {clientImgE ? (
                <div
                  style={{
                    display: "flex",
                    height: "120px",
                    alignItems: "center",
                  }}
                >
                  <Image
                    fixed={clientImgE.node.childImageSharp.fixed}
                    style={{ display: `flex`, margin: `1rem auto` }}
                  />
                </div>
              ) : (
                ""
              )}
              <p>
                Iris is an incredibly skilled film-maker. She has planned,
                filmed and edited a number of films in collaboration with us for
                our clients and they have always landed incredibly well. They
                are always beautifully composed and bring across a very human
                story. Beyond that, she's a joy to work with. She always comes
                with ideas and plenty of advice and her commitment to the best
                result is evident throughout the entire process. We love working
                with Iris!
              </p>
              <p>
                <strong>
                  <span style={{ textTransform: "uppercase" }}>
                    Bryony Simpson
                  </span>{" "}
                  <br />
                  Founder and CEO, WePioneer
                </strong>
              </p>
            </div>
            <div className="col col-6">
              {clientImgF ? (
                <div
                  style={{
                    display: "flex",
                    height: "120px",
                    alignItems: "center",
                  }}
                >
                  <Image
                    fixed={clientImgF.node.childImageSharp.fixed}
                    style={{ display: `flex`, margin: `1rem auto` }}
                  />
                </div>
              ) : (
                ""
              )}
              <p>
                Working with Iris on our Kickstarter video for the baby sound
                machine we invented was fantastic. From the get-go, she was
                super friendly and really understood our vision. She took our
                ideas and had great suggestions to make these even better.
              </p>
              <p>
                On filming day, she was amazing—especially given a newborn baby
                was involved! She was patient and made the most of what we had,
                which made the whole process easy and fun.
              </p>
              <p>
                The final video blew us away. It was even better than we had
                hoped and was worth every penny. You can tell she loves what she
                does. We'd work with her again in a heartbeat and highly
                recommend her to anyone needing a great video.
              </p>
              <p>
                <strong>
                  <span style={{ textTransform: "uppercase" }}>
                    Laurène &amp; Alan Mosely
                  </span>{" "}
                  <br />
                  Founders, SleepaSloth
                </strong>
              </p>
            </div>
          </div>

          <div className="grid">
            <div className="col col-6">
              {clientImgC ? (
                <div
                  style={{
                    display: "flex",
                    height: "120px",
                    alignItems: "center",
                  }}
                >
                  <Image
                    fixed={clientImgC.node.childImageSharp.fixed}
                    style={{ display: `flex`, margin: `1rem auto` }}
                  />
                </div>
              ) : (
                ""
              )}
              <p>
                'I can't stress how important it is to find an expert like Iris
                to guide you through this. No matter how amazing you think your
                iPhone is, your video isn't going to turn out well unless you
                have all the components correct.
              </p>
              <p>
                We all learn this lesson at some point. Save yourself from
                learning this the hard way and get Iris's help!'
              </p>
              <p>
                <strong>
                  KRISTINA HUDDART <br />
                  Marketing technology consultant
                </strong>
              </p>
            </div>
            <div className="col col-6">
              {clientImgD ? (
                <div
                  style={{
                    display: "flex",
                    height: "120px",
                    alignItems: "center",
                  }}
                >
                  <Image
                    fixed={clientImgD.node.childImageSharp.fixed}
                    style={{ display: `flex`, margin: `1rem auto` }}
                  />
                </div>
              ) : (
                ""
              )}
              <p>
                'Working with Iris was such a dream. She is so hard working and
                knowledgeable. She designed an amazing opening sequence to my
                yoga videos only using old videos I had filmed on my phone
                (because of COVID we couldn't meet in person).
              </p>
              <p>
                It looked extremely professional and I am thrilled with the
                result. On top of this she edited pretty much every video on my
                new app really efficiently and I am so happy with the final
                videos. I can't wait to meet Iris in person and work more
                together in future.'
              </p>
              <p>
                <strong>
                  HANNAH BARRETT <br />
                  Yoga teacher
                </strong>
              </p>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  )
}

export default About

export const pageQuery = graphql`
  query {
    mast: file(absolutePath: { regex: "/mast-about.jpg/" }) {
      childImageSharp {
        fluid(maxWidth: 1920, quality: 80) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    mastIris: file(absolutePath: { regex: "/mast-about-iris.jpg/" }) {
      childImageSharp {
        fluid(maxWidth: 1920, quality: 80) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    freelanceFilmIris: file(
      absolutePath: { regex: "/iris-freelance-filmmaker.jpg/" }
    ) {
      childImageSharp {
        fluid(maxWidth: 660, quality: 80) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    producersPerspective: file(
      absolutePath: { regex: "/producers-perspective.jpg/" }
    ) {
      childImageSharp {
        fluid(maxWidth: 660, quality: 80) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    longTermAsset: file(absolutePath: { regex: "/long-term-asset.jpg/" }) {
      childImageSharp {
        fluid(maxWidth: 660, quality: 80) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    onSet: file(absolutePath: { regex: "/on-set.jpg/" }) {
      childImageSharp {
        fluid(maxWidth: 660, quality: 80) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    videoProdKent: file(
      absolutePath: { regex: "/about-video-prod-kent.jpg/" }
    ) {
      childImageSharp {
        fluid(maxWidth: 460, quality: 100) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    avatar: file(absolutePath: { regex: "/profile-out-and-about.jpg/" }) {
      childImageSharp {
        fluid(maxWidth: 460, quality: 100) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    clients: allFile(
      filter: {
        extension: { regex: "/(png)/" }
        absolutePath: { regex: "/(logos/client)/" }
      }
    ) {
      totalCount
      edges {
        node {
          name
          childImageSharp {
            fixed(height: 90) {
              ...GatsbyImageSharpFixed_noBase64
            }
          }
        }
      }
    }
    profiles: allFile(
      filter: {
        extension: { regex: "/(png)|(jpg)/" }
        absolutePath: { regex: "/(profiles/profile)/" }
      }
    ) {
      totalCount
      edges {
        node {
          name
          childImageSharp {
            fluid(maxWidth: 660, maxHeight: 800, quality: 80) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`
